import React from 'react';

import ContentBlock, { ContentBlockProps } from 'app/components/ContentBlock';
import useGuest from 'app/hooks/useGuest';
import useRootNavigation from 'app/hooks/useRootNavigation';
import { hasOffers } from 'app/services/ProductHelper';
import { tID } from 'app/services/TestHelper';
import { isEntitlementSelectable } from 'app/utils/time';

export type ProductOffersProps = ContentBlockProps;

export default function ProductOffers(props: ProductOffersProps) {
  const navigation = useRootNavigation();
  const { activeEntitlement } = useGuest();

  const canAccessOffers = () => {
    if (!hasOffers(props.productContent)) {
      return false;
    }

    // Must have selectable entitlement (valid or expired within one week)
    return activeEntitlement ? isEntitlementSelectable(activeEntitlement) : false;
  };

  return (
    <ContentBlock
      {...props}
      bodyTestID={tID('OffersSubText')}
      ctaTestID={tID('GetSpecialOffersButton')}
      precondition={canAccessOffers}
      testID={tID('ProductOffers')}
      titleTestID={tID('OffersIntroText')}
      onCTAPress={() => {
        const params = { productId: props.productContent?.key ?? '' };
        navigation.navigate('Tabs', {
          screen: 'ProductStack',
          params: { screen: 'ProductOffers', params },
        });
      }}
    />
  );
}
